import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Typography, Box, IconButton, Stack, InputAdornment, DialogContentText } from '@mui/material';
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CircularProgress } from '@mui/material';

import { useAuth } from '../../../Auth/AuthContext';
import { getUniqueActiveCashbox } from '../../../utils/cashbox';
import { formatApiMoneyForInput, parseColombianMoneyInput } from '../../../utils/money';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';
import { sessionRequestConfig } from '../../../utils/csrf';

async function actualizarReporteDiario(valor) {
  const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' })

  const response = await axios.get(`${API_URL}/reporte_diario/`);
  const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === "M-I");

  try {
      if (reporteHoy) {
          const nuevoValor = parseFloat(reporteHoy.valor) + Number(valor);
          console.log(parseFloat(reporteHoy.valor) + ' | ' + Number(valor))
          console.log(nuevoValor)
          const responsePut = await axios.put(`${API_URL}/reporte_diario/${reporteHoy.id}/`, { valor: nuevoValor } );
          console.log(responsePut)
      } else {
          await axios.post(`${API_URL}/reporte_diario/`, { fecha: hoy, tipo: "M-I", valor: Number(valor) });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }

  try {
      const reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === "M-V");
      if (reporteHoy) {
          const responsePut = await axios.put(`${API_URL}/reporte_diario/${reporteHoy.id}/`, { valor: Number(reporteHoy.valor) + 1 } );
          console.log(responsePut)
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }
}

const API_URL = process.env.REACT_APP_API_URL;
export const buildRenewalCreationPayload = ({
  fechaEntrada,
  fechaSalida,
  valor,
  movimientoId,
  observaciones,
  usuario,
}) => ({
  fecha_entrada: fechaEntrada,
  fecha_salida: fechaSalida,
  valor: parseColombianMoneyInput(valor),
  movimiento: movimientoId,
  observaciones,
  usuario,
});

export const renewalCreationErrorMessage = (error) => {
  const code = error?.response?.data?.code;
  if (code === 'movement_required') {
    return 'La renovación requiere un movimiento financiero válido.';
  }
  if (code === 'movement_financial_inconsistent') {
    return 'El movimiento debe ser un ingreso de mensualidad.';
  }
  return getApiErrorMessage(
    error,
    'No fue posible renovar la mensualidad.',
    ['movimiento', 'renovaciones', 'historial', 'cliente']
  );
};

export default function DialogRenovarModify({ openDialog, handleCloseDialog, data, handleUpdateData }) {
  const { user } = useAuth();
  const [desde, setDesde] = useState();
  const [hasta, setHasta] = useState();
  const [valor, setValor] = useState();
  const [observaciones, setObservaciones] = useState();

  const [loading, setLoading] = useState(false);
  const submitRef = React.useRef(false);

  useEffect(() => {
    setDesde(!data.renovado ? new Date(`${data.fecha_inicio}T00:00:00`) : new Date(`${data.renovaciones[data.renovaciones.length - 1].fecha_entrada}T00:00:00`));
    setHasta(!data.renovado ? new Date(`${data.fecha_final}T00:00:00`) : new Date(`${data.renovaciones[data.renovaciones.length - 1].fecha_salida}T00:00:00`));
    const apiValue = !data.renovado
      ? (data.valorTicketModificado || data.valor)
      : data.valorTicketModificado;
    setValor(apiValue == null ? '' : formatApiMoneyForInput(apiValue));
    setObservaciones(!data.renovado ? data.observaciones : data.renovaciones[data.renovaciones.length - 1].observaciones);
  }, [data]);

  const [error, setError] = useState("");

  // Estados de errores por campo
  const [fieldErrors, setFieldErrors] = useState({
    desde: false,
    hasta: false,
    valor: false,
  });

  const validateFields = () => {
    const errors = {
      desde: desde === null,
      hasta: hasta === null,
      valor: valor === null,
    };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleSubmit = async () => {
    if (submitRef.current || loading) return;
    if (!validateFields()) {
      setError("Por favor, complete todos los campos.");
      return;
    }
    submitRef.current = true;
    setLoading(true);

    try {
    const cajaActual = await getUniqueActiveCashbox(API_URL, user);
    const canonicalValue = parseColombianMoneyInput(valor);

    const nuevoMovimiento = {
      tipo: "Ingreso",
      monto: canonicalValue,
      isME: 'mensualidad',
      observacion: `Ingreso por Renovación de Mensualidad (Cliente: ${data.cliente.nombre} ${data.cliente.apellidos} Vehiculo: ${data.historial.tipo_vehiculo} ${data.historial.color} ${data.historial.placa})`
    };
  
      let yearI = desde.getFullYear();
      let monthI = String(desde.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
      let dayI = String(desde.getDate()).padStart(2, '0');

      let yearF = hasta.getFullYear();
      let monthF = String(hasta.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
      let dayF = String(hasta.getDate()).padStart(2, '0');

      // 1. Crear la nueva renovación
      const renovacionResponse = await axios.post(
        `${API_URL}/renovaciones-mensualidad/`,
        {
          ...buildRenewalCreationPayload({
            fechaEntrada: `${yearI}-${monthI}-${dayI}`,
            fechaSalida: `${yearF}-${monthF}-${dayF}`,
            valor,
            observaciones,
            usuario: user.nombre,
          }),
          mensualidad_id: data.id,
          financial: {
            caja_id: cajaActual.id,
            movimiento: nuevoMovimiento,
          },
        },
        sessionRequestConfig()
      );
    
      if (renovacionResponse.status !== 201) {
        throw new Error("No se pudo crear la renovación");
      }
    
      if (renovacionResponse.status === 201) {
        await actualizarReporteDiario(canonicalValue);
        await handleUpdateData();
        handleCloseDialog();
      } else {
        throw new Error("Error al actualizar la mensualidad");
      }
    } catch (err) {
      console.log(err);
      setError(renewalCreationErrorMessage(err));
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  };

  return (
    <Dialog open={openDialog} onClose={handleCloseDialog}>

      <Backdrop
        open={loading}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogTitle>Renovar Mensualidad</DialogTitle>
      <DialogContent>

          <DialogContentText>
            Vas a renovar una mensualidad, ponga los datos para renovarla
          </DialogContentText>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Typography variant="subtitle2" sx={{ marginTop: 2 }}>DESDE:</Typography>
            <Stack>
              <DatePicker
                fullWidth
                variant='outlined'
                value={desde}
                onChange={(newValue) => { setDesde(newValue); setFieldErrors((prev) => ({ ...prev, desde: false })); }} // Resetear el error al cambiar la fecha
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={fieldErrors.desde} // Mostrar error si el campo está vacío
                    helperText={fieldErrors.desde ? "Este campo es obligatorio" : ""} // Mensaje de error
                  />
                )}
              />
              {fieldErrors.desde && <Typography color="error">Este campo es obligatorio</Typography>}  
            </Stack>

            <Typography variant="subtitle2" sx={{ marginTop: 2 }}>HASTA:</Typography>
            <Stack>
              <DatePicker
                fullWidth
                variant='outlined'
                value={hasta}
                onChange={(newValue) => { setHasta(newValue); setFieldErrors((prev) => ({ ...prev, hasta: false })); }} // Resetear el error al cambiar la fecha
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={fieldErrors.hasta} // Mostrar error si el campo está vacío
                    helperText={fieldErrors.hasta ? "Este campo es obligatorio" : ""} // Mensaje de error
                  />
                )}
              />
              {fieldErrors.hasta && <Typography color="error">Este campo es obligatorio</Typography>}  
            </Stack>
          </LocalizationProvider>

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>VALOR:</Typography>
          <TextField
            autoFocus
            fullWidth
            value={valor}
            type='text'
            inputMode='decimal'
            inputProps={{ maxLength: 20 }}
            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }}
            sx={{ textTransform: 'uppercase' }}
            onChange={(e) => { setValor(e.target.value); setFieldErrors((prev) => ({ ...prev, valor: false })); }} // Resetear el error al cambiar el valor
            error={fieldErrors.valor} // Mostrar error si el campo está vacío
            helperText={fieldErrors.valor ? "Este campo es obligatorio" : ""} // Mensaje de error
          />

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>OBSERVACIONES:</Typography>
          <TextField 
            autoFocus
            fullWidth 
            value={observaciones}
            onChange={(e) => {setObservaciones(e.target.value)}}
            sx={{ textTransform: 'uppercase' }}
          />

      </DialogContent>
      {error && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#d32f2f', padding: 1, borderRadius: 1, width: '95%' }}>
            <Typography sx={{ color: 'white', fontWeight: 'bold', marginRight: 1 }}>{error}</Typography>
            <IconButton color="inherit" onClick={() => setError("")}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      )}
      <DialogActions>
        <Button onClick={handleCloseDialog} variant="contained" color='error'>
          Cancelar
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="outlined" disabled={loading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
